module.exports = __webpack_public_path__ + "static/media/JMeter-logo.94761723.png";